<template>
  <div>
    <div v-if="weekend === null">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10"
                           md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div v-else>
      <md-toolbar class="md-dense" md-elevation="1" style="background-color: #FFFFFF">
        <div class="md-toolbar-section-start"></div>
        <h3 class="md-title">{{weekend.name}}<span><br/><small>{{weekend.start}} - {{weekend.end}}</small></span></h3>
        <div class="md-toolbar-section-end">
          <md-button class="md-icon-button" :to="'../weekend/' + weekend.versionedId.id">
            <md-icon>today</md-icon>
          </md-button>
        </div>
      </md-toolbar>

      <br/>

      <md-card>
        <md-card-header>
          <div class="md-title">Read Only Links</div>
        </md-card-header>
        <md-card-content>
          <a target="_blank"
             :href="'/api/zip/' + weekend.versionedId.id + '/' + weekend.name.toLowerCase().split(' ').join('_') + '.zip'">All
            PDFs</a>
          <br/>
          <br/>
          <a target="_blank" :href="'/static/view/master/#' + weekend.versionedId.id">Master Schedule</a>
          <br/>
          <br/>
          <div class="md-subheading">Sections</div>
          <div v-for="section in this.weekend.sections" :key="section.versionedId.id">
            <a target="_blank" :href="'/static/view/#' + weekend.versionedId.id + '/t/' + section.versionedId.id">{{section.name}}</a>
          </div>
          <br/>
          <div v-if="usedStaffList && usedStaffList.length > 0">
            <div class="md-subheading">Staff</div>
            <div v-for="staff in usedStaffList" :key="staff.versionedId.id">
              <a target="_blank" :href="'/static/view/#' + weekend.versionedId.id + '/s/' + staff.versionedId.id">{{staff.name}}</a>
            </div>
            <br/>
          </div>
          <div v-if="usedLocationList && usedLocationList.length > 0">
            <div class="md-subheading">Locations</div>
            <div v-for="location in usedLocationList" :key="location.versionedId.id">
              <a target="_blank" :href="'/static/view/#' + weekend.versionedId.id + '/l/' + location.versionedId.id">{{location.name}}</a>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <br/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "WeekendReports",
    data() {
      return {
        weekend: null,
        weekendSubscriptionId: null
      }
    },
    methods: {
      weekendChangeHandler(newWeekend) {
        this.weekend = newWeekend;
      }
    },
    computed: {
      locationList() {
        if (this.$store.state.currentCityDetails.rooms && this.$store.state.currentCityDetails.vehicles) {
          var locations = [];
          this.$store.state.currentCityDetails.rooms.forEach(location => locations.push(location));
          this.$store.state.currentCityDetails.vehicles.forEach(location => locations.push(location));
          return locations;
        } else {
          return [];
        }
      },
      staffList() {
        if (this.$store.state.currentCityDetails.staff) {
          var staff = [];
          this.$store.state.currentCityDetails.staff.forEach(staffMember => {
            staffMember.visibleName = staffMember.name + " (" + staffMember.initials + ")";
            staff.push(staffMember);
          });
          return staff;
        } else {
          return [];
        }
      },
      usedStaffList() {
        if (!this.weekend.activities) {
          return [];
        }

        var objectIds = [];
        this.weekend.activities.forEach(activity => {
          activity.staffAssignments.forEach(staffAssignment => {
            if (!objectIds.includes(staffAssignment.staffId.id))
              objectIds.push(staffAssignment.staffId.id);
          });
        });

        var objects = [];
        objectIds.forEach(id => {
          this.staffList.forEach(staffObject => {
            if (staffObject.versionedId.id === id)
              objects.push(staffObject);
          });
        });

        return objects;
      },
      usedLocationList() {
        if (!this.weekend.activities) {
          return [];
        }

        var objectIds = [];
        this.weekend.activities.forEach(activity => {
          if (activity.locationId && !objectIds.includes(activity.locationId.id))
            objectIds.push(activity.locationId.id);
        });

        var objects = [];
        objectIds.forEach(id => {
          this.locationList.forEach(location => {
            if (location.versionedId.id === id)
              objects.push(location);
          });
        });

        return objects;
      }
    },
    created() {
      this.weekendSubscriptionId = this.$store.api.subscribe("WEEKEND", this.$route.params.weekendId, this.weekendChangeHandler);
    },
    beforeDestroy() {
      if (this.weekendSubscriptionId)
        this.$store.api.unsubscribe(this.weekendSubscriptionId);

      this.weekendSubscriptionId = null;

      if (this.$refs.calendar)
        this.$refs.calendar.fireMethod('destroy');
    }
  }
</script>

<style scoped>
  .md-card {
    width: 320px;
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/city/weekend/WeekendReports.vue